export default __webpack_public_path__ + "static/media/UserAvatar.eb8cf00b.png";